var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = !(_vm.itemData.style.layout > -1) ? _vm.itemData.data.length : null
  var g1 = !(_vm.itemData.style.layout > -1) ? _vm.itemData.data.length : null
  var g2 = !(_vm.itemData.style.layout > -1) ? _vm.itemData.data.length : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        g1: g1,
        g2: g2,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }